import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import Paragraph from 'components/Paragraph';
import Strong from 'components/Strong';
import { IMAGE_RATIOS, IMAGE_WIDTHS } from 'constants/images';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const ProductTile = ({ product, variant }) => (
  <div className="ProductTile">
    <div className="ProductTile__image-container">
      <Image
        src={get(product, ['defaultImage', 'src'])}
        alt={get(product, ['defaultImage', 'alt'])}
        width={IMAGE_WIDTHS.W_600}
        ratio={IMAGE_RATIOS.R_1x1}
        coverParentNode
      />
    </div>
    <div className="ProductTile__info">
      <Paragraph className="ProductTile__edition">
        <Strong>{I18n.localize(`product.edition.${product.edition}`)}</Strong>: {product.colorName}
      </Paragraph>

      <Paragraph className="ProductTile__size">
        <Strong>{I18n.localize('product.size')}</Strong>: {variant.value}
      </Paragraph>
    </div>

    <style jsx>{`
      .ProductTile__image-container {
        aspect-ratio: 1 / 1;
        width: 235px;
        margin: 0 auto ${Theme.get('spacing') * 3}px;
      }

      .ProductTile__info {
        text-align: center;
      }
    `}</style>

    <style jsx global>{`
      .ProductTile .ProductTile__edition {
        margin-bottom: 0;
      }
    `}</style>
  </div>
);

ProductTile.propTypes = {
  product: PropTypes.shape({
    edition: PropTypes.string,
    colorName: PropTypes.string,
  }).isRequired,
  variant: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
};

ProductTile.defaultProps = {};

export default ProductTile;
